/** Off days and free times (api/app/routers/availability.py). */
import { api } from './api';

export interface TimeOff {
  id: string; user_id: string; name: string;
  starts_at: string; ends_at: string; all_day: boolean;
  note?: string | null; mine: boolean; can_remove: boolean;
}
export interface TimeOffIn {
  user_id?: string; start_date: string; end_date?: string;
  from_time?: string; to_time?: string; note?: string;
}
export interface FreeTimes { slots: string[]; away: string[] }

export const fetchTimeOff = async (userId?: string, days = 60) =>
  (await api.get<TimeOff[]>('/time-off', { params: { ...(userId ? { user_id: userId } : {}), days } })).data;
export const addTimeOff = async (body: TimeOffIn) => (await api.post<TimeOff>('/time-off', body)).data;
export const removeTimeOff = async (id: string) => { await api.delete(`/time-off/${id}`); };
export const fetchFreeTimes = async (userIds: string[], minutes = 30, days = 10) =>
  (await api.get<FreeTimes>('/availability', { params: { user_ids: userIds.join(','), minutes, days } })).data;

const DUBAI = 'Asia/Dubai';
const dayFmt = new Intl.DateTimeFormat('en-GB', { timeZone: DUBAI, weekday: 'short', day: 'numeric', month: 'short' });
const timeFmt = new Intl.DateTimeFormat('en-GB', { timeZone: DUBAI, hour: '2-digit', minute: '2-digit' });

/** "Mon 29 Sep", "Mon 29 Sep to Wed 1 Oct", or "Mon 29 Sep, 14:00 to 16:00" (Dubai time). */
export function offLabel(t: Pick<TimeOff, 'starts_at' | 'ends_at' | 'all_day'>): string {
  const s = new Date(t.starts_at);
  const e = new Date(t.ends_at);
  if (!t.all_day) return `${dayFmt.format(s)}, ${timeFmt.format(s)} to ${timeFmt.format(e)}`;
  const last = new Date(e.getTime() - 1);
  const a = dayFmt.format(s), b = dayFmt.format(last);
  return a === b ? a : `${a} to ${b}`;
}

/** Today in Dubai as YYYY-MM-DD, for date inputs. */
export function todayDubai(): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: DUBAI }).format(new Date());
}
